import angular from "angular"
import "../edition/edition"
import "../panel/panel"
import "front-end-web-commons"
import "../../bower_components/front-end-web-commons/app/maps/maps.less"
// dependência indireta de mapsModule
import "angular-simple-logger"

export default angular.module("carrierZoneModule", ["editionModule", "r2PanelModule", "mapsModule", "regionModule"])